import Reveal from "@/components/base/Reveal";
import { whatsappLink } from "@/constants/site";
import { vpsCards } from "@/mocks/home";

export default function VpsServers() {
  return (
    <section className="relative overflow-hidden bg-foreground-950 py-16 text-background-50 md:py-24">
      <div className="absolute inset-0 nx-grid opacity-25"></div>
      <div className="nx-glow absolute bottom-0 left-1/4 h-[420px] w-[420px] animate-pulseGlow"></div>

      <div className="relative mx-auto max-w-7xl px-4 md:px-8">
        <div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-2 lg:gap-16">
          <Reveal>
            <div className="overflow-hidden rounded-2xl border border-background-50/10">
              <img
                src="https://readdy.ai/api/search-image?query=futuristic%20cloud%20server%20infrastructure%20with%20glowing%20network%20connections%20and%20data%20center%20racks%2C%20dark%20navy%20and%20cyan%20technology%20visualization%2C%20premium%203d%20render&width=1200&height=800&seq=nh-vps-servers&orientation=landscape"
                alt="Servidores VPS e infraestrutura de nuvem conectados em data center"
                title="VPS e servidores dedicados NXHOST"
                loading="lazy"
                decoding="async"
                className="h-full w-full object-cover object-top"
              />
            </div>
          </Reveal>

          <Reveal delay={120}>
            <div>
              <span className="inline-flex items-center gap-2 rounded-full border border-background-50/15 bg-background-50/5 px-4 py-1.5 text-xs font-semibold uppercase tracking-wide text-accent-300">
                <i className="ri-hard-drive-3-line" aria-hidden="true"></i>
                VPS e servidores
              </span>
              <h2 className="mt-5 font-heading text-2xl font-bold tracking-tight md:text-4xl">
                Mais controle. Mais recursos. Mais possibilidades.
              </h2>
              <p className="mt-4 text-base leading-relaxed text-background-200">
                Para projetos que precisam de uma infraestrutura mais robusta, oferecemos soluções de
                VPS e servidores adequadas a diferentes necessidades.
              </p>

              <div className="mt-8 flex flex-col gap-4">
                {vpsCards.map((card) => (
                  <div
                    key={card.title}
                    className="flex items-start gap-4 rounded-xl border border-background-50/10 bg-background-50/5 p-5"
                  >
                    <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-primary-500/15 text-primary-300">
                      <i className={`${card.icon} text-xl`} aria-hidden="true"></i>
                    </span>
                    <div>
                      <h3 className="font-heading text-base font-semibold text-background-50">
                        {card.title}
                      </h3>
                      <p className="mt-1 text-sm leading-relaxed text-background-300">
                        {card.description}
                      </p>
                    </div>
                  </div>
                ))}
              </div>

              <a
                href={whatsappLink("Ola! Quero falar sobre VPS e servidores da NXHOST.")}
                target="_blank"
                rel="noopener noreferrer"
                className="mt-9 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
              >
                <i className="ri-customer-service-2-line text-lg" aria-hidden="true"></i>
                Falar com um especialista
              </a>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}